import { render, staticRenderFns } from "./MultiPricingForm.vue?vue&type=template&id=182f4962"
import script from "./MultiPricingForm.vue?vue&type=script&lang=js"
export * from "./MultiPricingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports